export const SAVED_FILTER_PAGE = {
  GLOBAL: "global",
  OPTIMIZER: "optimizer",
  WHALE_WATCH: "whale-watch",
  PREFERENCES: "preferences",
  EV_SNIPER: "ev-sniper",
  ESPORTS_DISCREPANCIES: "esports-discrepancies",
  ARBITRAGE: "arbitrage",
  LOW_HOLD: "low-hold",
  ONBOARDING_PREFERENCES: "onboarding_preferences",
  ONBOARDING_CHECKLIST: "onboarding_checklist",
  BET_LINK_NUDGE: "bet_link_nudge",
  DISMISSED_BETS: "dismissed_bets",
  SPORTSBOOK_PREFERENCES: "sportsbook_preferences",
} as const;

export const OPTIMIZER_MOBILE_VIEW_FILTER = "mobile-view";

export const TOUR_COMPLETED_FILTER = "tour_completed";

export const BET_LINK_NUDGE_DISMISSED_FILTER = "dismissed";

export type MobileView = "cards" | "table";

export type SavedFilterPage =
  (typeof SAVED_FILTER_PAGE)[keyof typeof SAVED_FILTER_PAGE];
